{
  "blockType": "feature-grid",
  "root": {
    "backgroundLayers": [
      {
        "color": "foreground/4",
        "dotSize": 1.5,
        "spacing": 32,
        "type": "dot-pattern"
      }
    ],
    "children": [
      {
        "children": [
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "duration": 500,
                "opacity": [
                  0,
                  1
                ],
                "translateY": [
                  20,
                  0
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.15,
                "trigger": "inView"
              }
            },
            "children": [
              {
                "className": "uppercase tracking-wider",
                "id": "fg-badge",
                "text": "Features",
                "type": "badge",
                "variant": "outline"
              },
              {
                "className": "text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl text-balance",
                "id": "fg-title",
                "level": "2",
                "text": "Built for speed, designed for scale",
                "type": "heading"
              },
              {
                "className": "text-lg leading-relaxed text-muted-foreground text-balance",
                "id": "fg-subtitle",
                "text": "Every feature has been carefully crafted to help you move faster without sacrificing quality.",
                "type": "text"
              }
            ],
            "className": "flex max-w-2xl flex-col items-center gap-4 text-center cogo-gap-element",
            "id": "fg-header",
            "type": "container"
          },
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "duration": 400,
                "opacity": [
                  0,
                  1
                ],
                "translateY": [
                  20,
                  0
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              },
              "stagger": 80
            },
            "children": [
              {
                "children": [
                  {
                    "children": [
                      {
                        "className": "h-5 w-5 text-primary",
                        "icon": "zap",
                        "id": "fg-1-icon",
                        "type": "icon"
                      }
                    ],
                    "className": "flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10",
                    "id": "fg-1-icon-wrap",
                    "type": "container"
                  },
                  {
                    "className": "text-lg font-semibold text-foreground",
                    "id": "fg-1-title",
                    "level": "3",
                    "text": "Instant Deployments",
                    "type": "heading"
                  },
                  {
                    "className": "text-sm leading-relaxed text-muted-foreground",
                    "id": "fg-1-desc",
                    "text": "Push to deploy in seconds. Automatic rollbacks, preview URLs, and zero-downtime updates out of the box.",
                    "type": "text"
                  }
                ],
                "className": "flex flex-col gap-4 cogo-gap-element",
                "id": "fg-cell-1",
                "type": "container"
              },
              {
                "children": [
                  {
                    "children": [
                      {
                        "className": "h-5 w-5 text-primary",
                        "icon": "shield-check",
                        "id": "fg-2-icon",
                        "type": "icon"
                      }
                    ],
                    "className": "flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10",
                    "id": "fg-2-icon-wrap",
                    "type": "container"
                  },
                  {
                    "className": "text-lg font-semibold text-foreground",
                    "id": "fg-2-title",
                    "level": "3",
                    "text": "Enterprise Security",
                    "type": "heading"
                  },
                  {
                    "className": "text-sm leading-relaxed text-muted-foreground",
                    "id": "fg-2-desc",
                    "text": "SOC 2 Type II certified. End-to-end encryption, SSO, RBAC, and detailed audit logs for every action.",
                    "type": "text"
                  }
                ],
                "className": "flex flex-col gap-4 cogo-gap-element",
                "id": "fg-cell-2",
                "type": "container"
              },
              {
                "children": [
                  {
                    "children": [
                      {
                        "className": "h-5 w-5 text-primary",
                        "icon": "globe",
                        "id": "fg-3-icon",
                        "type": "icon"
                      }
                    ],
                    "className": "flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10",
                    "id": "fg-3-icon-wrap",
                    "type": "container"
                  },
                  {
                    "className": "text-lg font-semibold text-foreground",
                    "id": "fg-3-title",
                    "level": "3",
                    "text": "Global Edge Network",
                    "type": "heading"
                  },
                  {
                    "className": "text-sm leading-relaxed text-muted-foreground",
                    "id": "fg-3-desc",
                    "text": "Deploy to 50+ edge locations worldwide. Your users always hit the nearest node for sub-50ms response times.",
                    "type": "text"
                  }
                ],
                "className": "flex flex-col gap-4 cogo-gap-element",
                "id": "fg-cell-3",
                "type": "container"
              },
              {
                "children": [
                  {
                    "children": [
                      {
                        "className": "h-5 w-5 text-primary",
                        "icon": "code-2",
                        "id": "fg-4-icon",
                        "type": "icon"
                      }
                    ],
                    "className": "flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10",
                    "id": "fg-4-icon-wrap",
                    "type": "container"
                  },
                  {
                    "className": "text-lg font-semibold text-foreground",
                    "id": "fg-4-title",
                    "level": "3",
                    "text": "Powerful APIs",
                    "type": "heading"
                  },
                  {
                    "className": "text-sm leading-relaxed text-muted-foreground",
                    "id": "fg-4-desc",
                    "text": "REST and GraphQL APIs with webhooks, rate limiting, and automatic versioning. Full OpenAPI spec included.",
                    "type": "text"
                  }
                ],
                "className": "flex flex-col gap-4 cogo-gap-element",
                "id": "fg-cell-4",
                "type": "container"
              },
              {
                "children": [
                  {
                    "children": [
                      {
                        "className": "h-5 w-5 text-primary",
                        "icon": "bar-chart-2",
                        "id": "fg-5-icon",
                        "type": "icon"
                      }
                    ],
                    "className": "flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10",
                    "id": "fg-5-icon-wrap",
                    "type": "container"
                  },
                  {
                    "className": "text-lg font-semibold text-foreground",
                    "id": "fg-5-title",
                    "level": "3",
                    "text": "Real-time Analytics",
                    "type": "heading"
                  },
                  {
                    "className": "text-sm leading-relaxed text-muted-foreground",
                    "id": "fg-5-desc",
                    "text": "Live dashboards showing user behavior, performance metrics, error rates, and custom business KPIs.",
                    "type": "text"
                  }
                ],
                "className": "flex flex-col gap-4 cogo-gap-element",
                "id": "fg-cell-5",
                "type": "container"
              },
              {
                "children": [
                  {
                    "children": [
                      {
                        "className": "h-5 w-5 text-primary",
                        "icon": "puzzle",
                        "id": "fg-6-icon",
                        "type": "icon"
                      }
                    ],
                    "className": "flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10",
                    "id": "fg-6-icon-wrap",
                    "type": "container"
                  },
                  {
                    "className": "text-lg font-semibold text-foreground",
                    "id": "fg-6-title",
                    "level": "3",
                    "text": "100+ Integrations",
                    "type": "heading"
                  },
                  {
                    "className": "text-sm leading-relaxed text-muted-foreground",
                    "id": "fg-6-desc",
                    "text": "Connect to Stripe, Salesforce, Slack, GitHub, and 100+ tools your team already uses. No extra plugins needed.",
                    "type": "text"
                  }
                ],
                "className": "flex flex-col gap-4 cogo-gap-element",
                "id": "fg-cell-6",
                "type": "container"
              }
            ],
            "className": "grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 cogo-gap-section",
            "id": "fg-grid",
            "type": "container"
          }
        ],
        "className": "mx-auto flex max-w-6xl flex-col items-center gap-14 cogo-gap-section",
        "id": "feature-grid-inner",
        "type": "container"
      }
    ],
    "className": "px-6 py-16 lg:py-24",
    "id": "feature-grid-root",
    "type": "section"
  },
  "schemaVersion": "2.0"
}
